export default __webpack_public_path__ + "static/media/gdpr compl.de369623.png";